import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const createArticleReaction = createAsyncThunk(
    'kbArticle/createArticleReaction',
    async ({ articleId, type, group_id }, { getState, rejectWithValue }) => {
        try {
            const { loginToken } = getState();
            const authToken = loginToken?.response?.token;

            const response = await axios.post(
                `${ROOT_URL}/kb/articles/react/${articleId}`,
                { type, group_id },
                {
                    headers: {
                        'Authorization': authToken ? `Bearer ${authToken}` : '',
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response.data;
        } catch (error) {
            console.error("Error adding article reaction:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    loading: false,
    error: null,
    success: false,
    data: null,
};

const createArticleReactionSlice = createSlice({
    name: 'createArticleReaction',
    initialState,
    reducers: {
        resetCreateArticleReactionState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createArticleReaction.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(createArticleReaction.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(createArticleReaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            });
    }
});

export const { resetCreateArticleReactionState } = createArticleReactionSlice.actions;
export default createArticleReactionSlice.reducer;
